import { ArrowLeft } from "lucide-react";
import { useProfileContext } from "../../context/ProfileContext";

type SupermarketAdventureHostProps = {
  onBack: () => void;
};

const SupermarketAdventureHost = ({ onBack }: SupermarketAdventureHostProps) => {
  const { selectedProfile } = useProfileContext();
  const studentId =
    typeof selectedProfile?.studentId === "number" ? selectedProfile.studentId : 0;
  const classId =
    typeof selectedProfile?.classId === "number" ? selectedProfile.classId : 1;
  const iframeSrc = `/supermarket-adventure/index.html?studentId=${encodeURIComponent(
    String(studentId)
  )}&classId=${encodeURIComponent(String(classId))}`;

  return (
    <div className="fixed inset-0 z-50 bg-black">
      <button
        type="button"
        onClick={onBack}
        className="absolute left-3 top-3 z-10 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/40 bg-black/45 text-white hover:bg-black/65"
        aria-label="Back to activities"
      >
        <ArrowLeft className="h-5 w-5" />
      </button>

      <iframe
        title="Supermarket Adventure"
        src={iframeSrc}
        className="h-full w-full border-0"
        allow="fullscreen"
      />
    </div>
  );
};

export default SupermarketAdventureHost;
